export default class FooterCTA {
  constructor(elem, APP) {
    this.elem = elem;
    this.cta = this.elem.querySelector(".js-cta");
    this.bg = this.elem.querySelector(".js-bg");
  }

  init() {
    if (this.cta) {
      this.cta.addEventListener("mouseover", () => {
        this.bg.classList.add("active");
      });
      this.cta.addEventListener("mouseout", () => {
        this.bg.classList.remove("active");
      });
    }
  }
}
